import API from '.';
export default {
    login: (post) => {
        return API.post('/tasks/login', post, { headers: {} });
    },
    logOut: (post) => {
        return API.post('/tasks/logout')
    },
    getMe: () => {
        return API.get('/crm/users/me')
    }

}